import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { dictionaryTermTypes } from "constants/dictionary";
import { selectDictionary } from "slices/dictionary/selectors";
import {
  hasSpecialRegexCharacters,
  hasSpecialWildcardCharacters,
  isWildcardExpression,
} from "utils/dictionary";

import {
  isColourValid,
  isExpressionValid,
} from "layout/dictionary/edit/helpers";

export const ERROR_MESSAGES = {
  EMPTY_EXPRESSION: {
    BRIEF: "Invalid expression",
    DETAILED: "Expression can't be empty",
  },
  WILDCARD_NOT_VALID: {
    BRIEF: "Invalid wildcard",
    DETAILED: "Invalid wildcard",
  },
  REGEXP_NOT_VALID: {
    BRIEF: "Invalid regular expression",
    DETAILED: "Invalid regular expression",
  },
  COLOUR_NOT_VALID: {
    BRIEF: "Highlight color mismatch",
    DETAILED:
      "This term also exists in a different category with a different color. Reset this back to the default color to continue",
  },
};

export const useValidatePopupExpression = (
  expert,
  expression,
  caseSensitive,
  colour,
  description,
  term
) => {
  const { categories } = useSelector(selectDictionary);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    // Expression can't be empty string
    if (expression === "") {
      setErrorMessage(ERROR_MESSAGES.EMPTY_EXPRESSION);
      return;
    }

    // Validate Interim Expression
    if (!isExpressionValid(expert, expression)) {
      setErrorMessage(
        expert
          ? ERROR_MESSAGES.REGEXP_NOT_VALID
          : ERROR_MESSAGES.WILDCARD_NOT_VALID
      );
      return;
    }

    // Validate Final Expression
    if (expert) {
      if (!hasSpecialRegexCharacters(expression)) {
        setErrorMessage(ERROR_MESSAGES.REGEXP_NOT_VALID);
        return;
      }
    } else if (
      !hasSpecialWildcardCharacters(expression) ||
      !isWildcardExpression(expression)
    ) {
      setErrorMessage(ERROR_MESSAGES.WILDCARD_NOT_VALID);
      return;
    }

    // Validate colour
    const editedTerm = {
      ...term,
      name: expression,
      caseSensitive,
      colour,
      description,
      dictionaryTermType: expert
        ? dictionaryTermTypes.REGULAR_EXPRESSION
        : dictionaryTermTypes.WILDCARD_EXPRESSION,
    };
    if (!isColourValid(editedTerm, categories)) {
      setErrorMessage(ERROR_MESSAGES.COLOUR_NOT_VALID);
      return;
    }

    setErrorMessage(null);
  }, [expression, expert, caseSensitive, colour]);

  return errorMessage;
};
